<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" md="7">
        <div class="pa-2">
          <h1 class="txtLarge notBold">
            Welcome to
            <span>
              <b class="color_default">
                Integrated Learning Management Platform
              </b>
            </span>
          </h1>
          <div class="d-flex align-center mb-3" v-if="profile">
            <v-avatar dark size="70" class="mr-3">
              <img
                :src="profile.profile_picture ? profile.profile_picture : avalg"
                alt="avatar"
                class="obj_fit"
              />
            </v-avatar>
            <div>
              <h3 class="txtLarge notBold">
                {{ profile.name }}
              </h3>
              <p class="ma-0">
                {{ permissions[0] }}
              </p>
            </div>
          </div>
          <div class="temp_scroll">
            <div class="temp_card">
              <v-row v-if="dataSet" no-gutters>
                <v-col cols="4">
                  <div class="pa-2">
                    <v-card
                      class="pa-3 rounded-lg d-flex align-center"
                      flat
                      height="100px"
                    >
                      <v-icon color="var(--g)" size="50" class="mr-2"
                        >mdi-google-classroom</v-icon
                      >
                      <div>
                        <h3 class="color_default">{{ dataSet.countCohort }}</h3>
                        <p class="default_txt">Group</p>
                      </div>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="pa-2">
                    <v-card
                      class="pa-3 rounded-lg d-flex align-center"
                      flat
                      height="100px"
                    >
                      <v-icon color="indigo" size="50" class="mr-2"
                        >mdi-book</v-icon
                      >
                      <div>
                        <h3 class="indigo--text">{{ dataSet.countCourse }}</h3>
                        <p class="default_txt">Course</p>
                      </div>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="pa-2">
                    <v-card
                      class="pa-3 rounded-lg d-flex align-center"
                      flat
                      height="100px"
                    >
                      <v-icon color="orange" size="50" class="mr-2"
                        >mdi-face-man-shimmer</v-icon
                      >
                      <div>
                        <h3 class="orange--text">{{ dataSet.countScholar }}</h3>
                        <p class="default_txt">Scholars</p>
                      </div>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-row v-if="dataSet" no-gutters>
            <v-col cols="12 " md="6">
              <div class="pa-2">
                <v-card
                  flat
                  class="pa-3 rounded-lg"
                  height="100%"
                  v-if="optProposal"
                >
                  <h2 class="mb-2">Proposal</h2>
                  <div class="d-flex align-center mr-2">
                    <div class="bullet mr-2" style="background: #421eb7"></div>
                    <p class="mb-0">Internship</p>
                  </div>
                  <div class="d-flex align-center mr-2">
                    <div class="bullet mr-2" style="background: #006341"></div>
                    <p class="mb-0">Sponsorship</p>
                  </div>
                  <div class="d-flex align-center mr-2">
                    <div class="bullet mr-2" style="background: #f2a336"></div>
                    <p class="mb-0">GEP</p>
                  </div>
                  <apexchart
                    type="radialBar"
                    height="330"
                    :options="optProposal.options"
                    :series="optProposal.series"
                  ></apexchart>
                  <v-btn block depressed dark color="var(--g)"
                    >Manage Proposal</v-btn
                  >
                </v-card>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <v-row no-gutters>
                <v-col cols="6">
                  <div class="pa-2">
                    <v-card
                      class="pa-3 d-flex flex-column align-center rounded-lg"
                      height="150px"
                      flat
                    >
                      <v-icon color="var(--g)" size="50"
                        >mdi-account-arrow-up</v-icon
                      >
                      <h3 class="color_default text-center">
                        {{ dataSet.countAlumniDev }}
                      </h3>
                      <p class="default_txt text-center">
                        Alumni Engagement Activity
                      </p>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="pa-2">
                    <v-card
                      class="pa-3 d-flex flex-column align-center rounded-lg"
                      height="150px"
                      flat
                    >
                      <v-icon color="var(--g)" size="50">mdi-school</v-icon>
                      <h3 class="color_default text-center">
                        {{ dataSet.countGraduation }}
                      </h3>
                      <p class="default_txt text-center">Graduation</p>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="pa-2">
                    <v-card
                      class="pa-3 d-flex flex-column align-center rounded-lg"
                      height="150px"
                      flat
                    >
                      <v-icon color="var(--g)" size="50"
                        >mdi-human-greeting-proximity</v-icon
                      >
                      <h3 class="color_default text-center">
                        {{ dataSet.countComms }}
                      </h3>
                      <p class="default_txt text-center">Comms TELADAN</p>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="pa-2">
                    <v-card
                      class="pa-3 d-flex flex-column align-center rounded-lg"
                      height="150px"
                      flat
                    >
                      <v-icon color="var(--g)" size="50"
                        >mdi-calendar-month</v-icon
                      >
                      <h3 class="color_default text-center">
                        {{ dataSet.countMikroEvent }}
                      </h3>
                      <p class="default_txt text-center">Micro Event</p>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="pa-2">
                    <!-- <v-card class="rounded-lg" height="150px" flat>
                      <div
                        class="pa-3 bg_default"
                        style="border-radius: 10px 10px 0 0"
                      >
                        <p class="small_txt mb-0 white--text">
                          Contracts Not Approve
                        </p>
                        <h3 class="white--text">
                          {{ dataSet.countContract.declined }}%
                        </h3>
                      </div>
                      <div class="pa-3 d-flex align-center">
                        <h1 class="color_default mr-3">
                          {{ dataSet.countContract.approved }}%
                        </h1>
                        <p class="mb-0">Total Contracts Approved</p>
                      </div>
                    </v-card> -->
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <div class="pa-2">
                <!-- <v-card flat class="rounded-lg">
                  <v-tabs
                    color="#006341"
                    v-model="tab"
                    show-arrows
                    slider-size="4"
                  >
                    <v-tab class="text-capitalize">
                      <b>Alumni Dev Plan</b>
                    </v-tab>
                    <v-tab class="text-capitalize">
                      <b>Business Acumen</b>
                    </v-tab>
                    <v-tab class="text-capitalize">
                      <b>Graduation</b>
                    </v-tab>

                    <v-tab class="text-capitalize"> <b>Youth Summit</b> </v-tab>
                  </v-tabs>
                  <v-tabs-items
                    v-model="tab"
                    class="mt-3"
                    style="background: none"
                  >
                    <v-tab-item class="pa-3">
                      <div class="d-flex align-center justify-space-between">
                        <h3>Average proposed budget</h3>
                        <h1 class="color_default">
                          Rp. {{ dataSet.supportAndNetwork.alumniDev.budget }}
                        </h1>
                      </div>
                    </v-tab-item>
                    <v-tab-item class="pa-3">
                      <div class="d-flex align-center justify-space-between">
                        <h3>Average proposed budget</h3>
                        <h1 class="color_default">
                          Rp.
                          {{ dataSet.supportAndNetwork.businessAcument.budget }}
                        </h1>
                      </div>
                    </v-tab-item>
                    <v-tab-item class="pa-3">
                      <div class="d-flex align-center justify-space-between">
                        <h3>Average proposed budget</h3>
                        <h1 class="color_default">
                          Rp. {{ dataSet.supportAndNetwork.graduation.budget }}
                        </h1>
                      </div>
                    </v-tab-item>
                    <v-tab-item class="pa-3">
                      <div class="d-flex align-center justify-space-between">
                        <h3>Average proposed budget</h3>
                        <h1 class="color_default">
                          Rp. {{ dataSet.supportAndNetwork.youthSummit.budget }}
                        </h1>
                      </div>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card> -->
              </div>
            </v-col>
            <v-col cols="12">
              <div class="pa-2">
                <v-card flat v-if="optIp">
                  <h3 class="pa-2">GPA Per Cohort</h3>
                  <v-row no-gutters class="pa-2" justify="space-between">
                    <v-col cols="12" md="5" class="mb-2">
                      <p class="default_txt">Search by Semester</p>
                      <v-select
                        item-text="txt"
                        item-value="val"
                        :items="optSemester"
                        v-model="filter_semester"
                        dense
                        hide-details
                        placeholder="Click here"
                        outlined
                        @change="fetchIp"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="5">
                      <p class="default_txt">Filter by Academic Year</p>
                      <v-select
                        item-text="txt"
                        item-value="val"
                        :items="optYearAcademic"
                        v-model="filter_year_academic"
                        dense
                        hide-details
                        placeholder="Click here"
                        outlined
                        @change="fetchIp"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-skeleton-loader
                    class="ma-3"
                    type="image"
                    height="250"
                    v-if="loading_gpa"
                  ></v-skeleton-loader>
                  <apexchart
                    v-if="!loading_gpa"
                    height="250"
                    type="area"
                    :options="optIp.options"
                    :series="optIp.series"
                  ></apexchart>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" md="5">
        <div class="pa-2">
          <v-card class="mb-3 pa-3" flat>
            <v-card
              class="pa-1 mb-2 d-flex justify-center align-center"
              flat
              color="blue"
              dark
              @click="createData"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              <p class="mb-0 text-center"><b>Add Announcement</b></p>
            </v-card>
            <v-card
              class="pa-1 d-flex justify-center align-center"
              flat
              color="green"
              dark
              to="/scholar-announcement"
            >
              <v-icon class="mr-2">mdi-cog</v-icon>
              <p class="mb-0 text-center"><b>Manage Announcement</b></p>
            </v-card>
          </v-card>
          <v-card flat class="mb-3" v-if="optYear">
            <h3 class="pa-2">Graduates Per Year</h3>
            <apexchart
              type="line"
              height="300"
              :options="optYear.options"
              :series="optYear.series"
            ></apexchart>
          </v-card>
          <h3 class="pa-2">Demography</h3>
          <v-card flat class="mb-3">
            <h3 class="pa-2">Active Scholars</h3>

            <div v-if="optGenderActive">
              <apexchart
                width="350"
                type="pie"
                :options="optGenderActive.options"
                :series="optGenderActive.series"
              ></apexchart>
            </div>
          </v-card>
          <v-card flat class="mb-3">
            <h3 class="pa-2">Total Scholars</h3>

            <div v-if="optGenderAcumulative">
              <apexchart
                width="350"
                type="pie"
                :options="optGenderAcumulative.options"
                :series="optGenderAcumulative.series"
              ></apexchart>
            </div>
          </v-card>
          <v-card flat class="mb-3">
            <v-row no-gutters class="pa-2" justify="space-between">
              <v-col cols="12" md="5" class="mb-2">
                <h3>University</h3>
              </v-col>
              <v-col cols="12" md="7">
                <p class="default_txt">Search Cohort</p>
                <v-select
                  item-text="txt"
                  item-value="val"
                  :items="optCohort"
                  v-model="filter_cohort"
                  dense
                  hide-details
                  placeholder="Click here"
                  outlined
                  @change="fetchData()"
                ></v-select>
              </v-col>
            </v-row>
            <div v-if="optUniv">
              <apexchart
                type="bar"
                height="350"
                :options="optUniv.options"
                :series="optUniv.series"
              ></apexchart>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <div class="pa-2">
      <create-announ
        :c_announ="c_announ"
        :type="d_type"
        @close="c_announ = false"
        :inventory="inventory"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CreateAnnoun from "../Announcement/createAnnoun.vue";
export default {
  name: "overviewTF",
  components: { CreateAnnoun },
  computed: {
    ...mapState({
      profile: (state) => state.profile,
      ava: (state) => state.ava,
      avalg: (state) => state.ava_lg,
      permissions: (state) => state.permissions,
    }),
  },
  data() {
    return {
      loading: false,
      loading_gpa: false,
      dataSet: null,
      optProposal: null,
      optGenderActive: null,
      optGenderAcumulative: null,
      optUniv: null,
      optYear: null,
      tab: null,
      optIp: null,
      announ: null,
      c_announ: false,
      d_type: "",
      inventory: null,
      optSemester: [
        { txt: "All", val: "" },
        { txt: "Ganjil", val: "ganjil" },
        { txt: "Genap", val: "genap" },
      ],
      filter_semester: "",
      optYearAcademic: [{ txt: "All", val: "" }],
      filter_year_academic: "",
      year_today: new Date().getFullYear(),
      filter_cohort: "",
      optCohort: [{ txt: "All", val: "" }],
    };
  },
  mounted() {
    this.fetchData();
    this.fetchIp();
    for (let index = 2019; index <= this.year_today; index++) {
      this.optYearAcademic.push({
        txt: index + "/" + (index + 1),
        val: index + "/" + (index + 1),
      });
      this.optCohort.push({ txt: index, val: index });
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `overview/tf?year=` + this.filter_cohort,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data;
          this.chartProposal(data.countProposal);
          this.chartGenderActive(data.countScholarGender.aktif);
          this.chartGenderAcumulative(data.countScholarGender.akumulatif);
          this.chartyear(data.graduatePerYear);
          this.chartUniv(data.universityDemography);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchIp() {
      this.loading_gpa = true;
      let data = {
        path:
          `overview/tf/ip?year=` +
          this.filter_year_academic +
          `&semester=` +
          this.filter_semester,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading_gpa = false;
          this.chartIp(data);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading_gpa = false;
        });
    },
    chartIp(data) {
      let attr = [];
      let val = [];
      data.forEach((el) => {
        val.push(el.average);
        attr.push(el.year);
      });
      let s_obj = {
        key: attr,
        val: val,
      };
      let series = [
        {
          name: "scholar",
          data: s_obj.val,
        },
      ];
      let options = {
        chart: {
          id: "line",
          toolbar: {
            show: false,
          },
        },

        markers: {
          size: 5,
        },
        colors: ["#008448"],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: s_obj.key,
        },
        yaxis: {
          tickAmount: 1,
          labels: {
            formatter: (value) => {
              return value;
            },
          },
        },
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false, //or just here to disable only x axis grids
            },
          },
        },
      };

      this.optIp = {
        options: options,
        series: series,
      };
    },
    chartyear(data) {
      let attr = [];
      let val = [];
      data.forEach((el) => {
        val.push(el.total);
        attr.push(el.graduateAt);
      });
      let s_obj = {
        key: attr,
        val: val,
      };
      let series = [
        {
          name: "scholar",
          data: s_obj.val,
        },
      ];
      let options = {
        chart: {
          id: "area",
          toolbar: {
            show: false,
          },
        },

        // markers: {
        //   size: 5,
        // },
        colors: ["#F2A336"],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: s_obj.key,
        },
        yaxis: [
          {
            tickAmount: 1,
          },
        ],
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false, //or just here to disable only x axis grids
            },
          },
        },
      };

      this.optYear = {
        options: options,
        series: series,
      };
    },
    chartGenderActive(data) {
      let series = [];
      for (let key in data) {
        series.push(data[key]);
      }

      let options = {
        chart: {
          id: "vuechart-example",
        },
        colors: ["#99c1b4", "#006341"],
        labels: ["Female", "Male"],
      };

      this.optGenderActive = {
        options: options,
        series: series,
      };
    },
    chartGenderAcumulative(data) {
      let series = [];
      for (let key in data) {
        series.push(data[key]);
      }

      let options = {
        chart: {
          id: "vuechart-example",
        },
        colors: ["#99c1b4", "#006341"],
        labels: ["Female", "Male"],
      };

      this.optGenderAcumulative = {
        options: options,
        series: series,
      };
    },
    chartProposal(data) {
      let series = [];
      let label = [];
      for (let key in data) {
        label.push(key);
        // series.push(24);
        series.push(data[key]);
      }
      this.optProposal = {
        series: series,
        options: {
          chart: {
            height: 350,
            type: "radialBar",
          },
          colors: ["#421EB7", "#006341", "#F2A336"],
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: "22px",
                },
                value: {
                  fontSize: "16px",
                },
              },
              total: {
                show: true,
                label: "Total",
              },
            },
          },
          labels: label,
        },
      };
    },
    chartUniv(data) {
      let attr = [];
      let val = [];
      data.forEach((el) => {
        switch (el.name.toLowerCase()) {
          case "institut teknologi bandung":
            attr.push("ITB");
            break;
          case "institut pertanian bogor":
            attr.push("IPB");
            break;
          case "universitas pendidikan indonesia":
            attr.push("UPI");
            break;
          case "universitas gadjah mada":
            attr.push("UGM");
            break;
          case "universitas andalas":
            attr.push("UNAND");
            break;
          case "universitas brawijaya":
            attr.push("UB");
            break;
          case "universitas diponegoro":
            attr.push("UNDIP");
            break;
          case "universitas indonesia":
            attr.push("UI");
            break;
          case "universitas sumatera utara":
            attr.push("USU");
            break;
          case "universitas negeri riau":
            attr.push("UNRI");
            break;
          case "universitas riau":
            attr.push("UNRI");
            break;
          case "universitas hasanuddin":
            attr.push("UNHAS");
            break;
          case "universitas mulawarman":
            attr.push("UNMUL");
            break;
          default:
            attr.push(el.name);
            break;
        }
        val.push(el.total);
      });

      let s_obj = {
        key: attr,
        val: val,
      };
      let options = {
        chart: {
          id: "bar",
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        colors: ["#008448"],
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 10,
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        // stroke: {
        //   show: true,
        //   width: 3,
        //   colors: ["transparent"],
        // },
        xaxis: {
          categories: s_obj.key,
        },
        fill: {
          opacity: 1,
        },
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false, //or just here to disable only x axis grids
            },
          },
        },
      };

      let series = [
        {
          name: "scholar",
          data: s_obj.val,
        },
      ];

      this.optUniv = {
        options: options,
        series: series,
      };
    },

    createData() {
      let body = {
        title: "",
        description: "",
        image: null,
        year_tf: "all",
      };
      this.inventory = body;
      this.d_type = "create";
      this.c_announ = true;
    },
  },
};
</script>

<style scoped>
.bullet {
  border-radius: 50%;
  height: 15px;
  width: 15px;
}
@media (max-width: 637px) {
  .temp_scroll {
    overflow: hidden;
    overflow-x: auto;
  }
  .temp_card {
    width: 600px;
  }
}
</style>
